import { Modal } from '@deity-io/portal-ui';
import type { Dispatch, FC, SetStateAction } from 'react';

type ConfirmationModalProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  entityType: 'endpoint' | 'package' | 'package version' | 'flow' | 'mapping' | 'structure' | 'test data';
  entityUuid?: string;
  actionType?: 'delete' | 'undeploy';
  confirmText?: string;
  loading?: boolean;
  onConfirm: (uuid?: string) => void;
};
export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  isOpen,
  setIsOpen,
  entityType,
  onConfirm,
  entityUuid,
  loading = false,
  actionType = 'delete',
  confirmText = 'Delete'
}) => {
  const handleOnClose = event => {
    event.stopPropagation();
    setIsOpen(false);
  };

  const handleOnConfirm = event => {
    event.stopPropagation();
    onConfirm(entityUuid);
    setIsOpen(false);
  };

  return (
    <Modal
      onClose={handleOnClose}
      isOpen={isOpen}
      title="Are you sure?"
      label="Confirm"
      confirmText={confirmText}
      isLoading={loading}
      onConfirm={handleOnConfirm}
    >
      <p>{`You are about to ${actionType} this ${entityType}. Are you sure?`}</p>
    </Modal>
  );
};
